(() => {
  'use strict';
  const key = 'tucaboo:wishlist:v1';
  const dialog = document.getElementById('TucaBooWishlist');
  const toast = document.querySelector('[data-wish-toast]');
  let saved = [], timer, opener, requestVersion = 0;
  const valid = value => Array.isArray(value) ? [...new Set(value.filter(x => typeof x === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(x)))].slice(0, 100) : [];
  try { saved = valid(JSON.parse(localStorage.getItem(key) || '[]')); } catch (_) { /* Keep working in memory if storage is unavailable. */ }
  const announce = message => {
    if (!toast) return;
    toast.textContent = message; toast.hidden = false;
    clearTimeout(timer); timer = setTimeout(() => { toast.hidden = true; }, 3500);
  };
  function refreshButtons() {
    document.querySelectorAll('[data-wish-handle]').forEach(button => {
      const active = saved.includes(button.dataset.wishHandle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Save'} ${button.dataset.wishTitle || 'product'} ${active ? 'from' : 'to'} wishlist`);
      const label = button.querySelector('[data-wish-label]');
      if (label) { const text = active ? 'Saved to wishlist' : 'Save to wishlist'; if (label.textContent !== text) label.textContent = text; }
    });
    document.querySelectorAll('[data-open-wishlist]').forEach(b => { b.hidden = false; });
    document.querySelectorAll('[data-wish-count]').forEach(el => { el.textContent = String(saved.length); });
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); return true; } catch (_) { return false; }
  }
  const node = (tag, className, text) => {
    const el = document.createElement(tag); if (className) el.className = className;
    if (text !== undefined) el.textContent = text; return el;
  };
  const root = window.Shopify?.routes?.root || '/';
  function productPath(handle) { return `${root}products/${encodeURIComponent(handle)}`; }
  function money(value) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:window.Shopify?.currency?.active || 'GBP'}).format(value / 100); }
    catch (_) { return (value / 100).toFixed(2); }
  }
  async function renderWishlist() {
    if (!dialog) return;
    const version = ++requestVersion;
    const list = dialog.querySelector('[data-wishlist-items]');
    list.replaceChildren();
    if (!saved.length) {
      list.append(node('p', '', 'Your wishlist is waiting for a little colour. Tap a heart to save your favourite socks.'));
      const link = node('a', 'tb-button', 'Explore the socks'); link.href = `${root}collections/all`; list.append(link); return;
    }
    list.setAttribute('aria-busy', 'true');
    list.append(node('p', '', 'Finding your favourites…'));
    const handles = [...saved];
    const results = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(`${productPath(handle)}.js`, {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Unavailable');
        return {handle,product:await response.json()};
      } catch (_) { return {handle,product:null}; }
    }));
    if (version !== requestVersion) return;
    list.replaceChildren(); list.removeAttribute('aria-busy');
    results.forEach(({handle,product}) => {
      const row = node('article', 'tb-wishlist-item');
      if (product?.featured_image) {
        const image = node('img');
        const url = new URL(product.featured_image, location.origin);
        if (['https:', 'http:'].includes(url.protocol)) { url.searchParams.set('width','180'); image.src = url.href; }
        image.alt = product.title; image.loading = 'lazy'; row.append(image);
      } else row.append(node('div'));
      const info = node('div');
      const titleLink = node('a'); titleLink.href = productPath(handle);
      titleLink.append(node('h3', '', product?.title || handle.replaceAll('-', ' '))); info.append(titleLink);
      info.append(node('p', '', product ? `${product.price_varies ? 'From ' : ''}${money(product.price)}${product.available ? '' : ' · Sold out'}` : 'This item is currently unavailable.'));
      if (product) { const link = node('a', 'tb-button', product.available ? 'Choose your pair' : 'View product'); link.href = productPath(handle); info.append(link); }
      row.append(info);
      const remove = node('button', '', '×'); remove.type = 'button'; remove.dataset.removeWish = handle;
      remove.setAttribute('aria-label', `Remove ${product?.title || handle} from wishlist`); row.append(remove); list.append(row);
    });
  }
  document.addEventListener('click', event => {
    const readMore = event.target.closest('[data-open-description]');
    if (readMore) {
      const details = document.querySelector(readMore.getAttribute('href'));
      if (details) {
        event.preventDefault();
        details.open = true;
        details.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
      }
      return;
    }
    const wish = event.target.closest('[data-wish-handle]');
    if (wish) {
      const handle = wish.dataset.wishHandle;
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      const active = saved.includes(handle);
      if (!active && saved.length >= 100) { announce('Your wishlist holds up to 100 favourites. Remove a pair to make room.'); return; }
      saved = active ? saved.filter(x => x !== handle) : [...saved,handle];
      const stored = persist(); refreshButtons();
      announce(stored ? (active ? 'Removed from your wishlist.' : 'Saved to your wishlist.') : 'Browser storage is unavailable. Your wishlist will last for this visit only.');
      return;
    }
    const open = event.target.closest('[data-open-wishlist]');
    if (open && dialog) {
      opener = open;
      if (!dialog.open) dialog.showModal();
      renderWishlist(); return;
    }
    if (event.target.closest('[data-close-wishlist]') && dialog) dialog.close();
    const remove = event.target.closest('[data-remove-wish]');
    if (remove) {
      saved = saved.filter(x => x !== remove.dataset.removeWish); persist(); refreshButtons();
      renderWishlist().then(() => dialog.querySelector('[data-close-wishlist]').focus());
    }
  });
  dialog?.addEventListener('close', () => opener?.focus());
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { saved = valid(JSON.parse(event.newValue || '[]')); } catch (_) { saved = []; }
    refreshButtons(); if (dialog?.open) renderWishlist();
  });
  document.addEventListener('shopify:section:load', refreshButtons);
  // Dawn replaces product cards during filtering and product recommendations load asynchronously.
  new MutationObserver(records => { if (records.some(r => r.addedNodes.length)) refreshButtons(); }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  refreshButtons();

  class TucaBooCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.track = this.querySelector('.tb-track');
      this.controls = this.querySelector('.tb-carousel-controls');
      if (!this.track || !this.controls) return;
      this.previous = this.querySelector('[data-prev]'); this.next = this.querySelector('[data-next]');
      const move = direction => {
        const width = this.track.children[0]?.getBoundingClientRect().width || this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({left: direction * (width + gap) * Number(this.dataset.step || 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(-1)); this.next.addEventListener('click', () => move(1));
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 3;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        const width = (this.track.children[0]?.getBoundingClientRect().width || 1) + (parseFloat(getComputedStyle(this.track).gap) || 0);
        const first = Math.round(this.track.scrollLeft / width) + 1;
        const visible = Math.max(1, Math.round((this.track.clientWidth + (parseFloat(getComputedStyle(this.track).gap) || 0)) / width));
        this.querySelector('[data-position]').textContent = `${first}–${Math.min(first + visible - 1,this.track.children.length)} / ${this.track.children.length}`;
      };
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update); this.observer.observe(this.track); this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  }
  if (!customElements.get('tb-carousel')) customElements.define('tb-carousel', TucaBooCarousel);
})();
